import { ChevronDown } from 'lucide-react'

const BANNER_IMAGE = 'http://dingtalk-aioa.oss-cn-zhangjiakou.aliyuncs.com/generated_images%2F20260321_145149_b3c0647a.png?OSSAccessKeyId=LTAI5tEzpHuJTvr78D3mQewM&Expires=2089435909&Signature=pU3KAA7yGYRDDY5MOThtbsiynHo%3D'

function Banner() {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${BANNER_IMAGE})`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/50 to-white"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-semibold text-apple-gray-900 tracking-tight mb-6">
          Premium Nonwoven Bags
        </h1>
        <p className="text-xl md:text-2xl text-apple-gray-600 font-light mb-4 max-w-3xl mx-auto">
          Custom Manufacturing Solutions
        </p>
        <div className="inline-block px-6 py-3 bg-apple-gray-900 text-white rounded-full text-sm font-medium mb-8">
          MOQ 1 Piece for Sampling · Bulk Production After Confirmation
        </div>
        
        <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
          <a
            href="#quote"
            className="px-8 py-4 bg-apple-gray-900 text-white rounded-full text-sm font-medium hover:bg-apple-gray-800 transition-colors"
          >
            Get Free Quote
          </a>
          <a
            href="#products"
            className="px-8 py-4 border border-apple-gray-300 text-apple-gray-900 rounded-full text-sm font-medium hover:bg-apple-gray-50 transition-colors"
          >
            View Products
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-apple-gray-400" size={32} />
      </div>
    </section>
  )
}

export default Banner
